import API from '../../../constants/api';

export const FETCH_EXEMPTED_POLICY_BUNDLES = '@@exemptedPolicyBundles/FETCH_EXEMPTED_POLICY_BUNDLES';
export const FETCH_EXEMPTED_POLICY_BUNDLES_SUCCESS = '@@exemptedPolicyBundles/FETCH_EXEMPTED_POLICY_BUNDLES_SUCCESS';
export const FETCH_EXEMPTED_POLICY_BUNDLES_FAILURE = '@@exemptedPolicyBundles/FETCH_EXEMPTED_POLICY_BUNDLES_FAILURE';

export const DOWNLOAD_EXEMPTED_BUNDLE_REQUEST = '@@exemptedPolicyBundles/DOWNLOAD_EXEMPTED_BUNDLE_REQUEST';
export const DOWNLOAD_EXEMPTED_BUNDLE_SUCCESS = '@@exemptedPolicyBundles/DOWNLOAD_EXEMPTED_BUNDLE_SUCCESS';
export const DOWNLOAD_EXEMPTED_BUNDLE_FAILURE = '@@exemptedPolicyBundles/DOWNLOAD_EXEMPTED_BUNDLE_FAILURE';


export const downloadExemptedBundleRequest = (uuid, successCallback, failureCallBack) => ({
    type: DOWNLOAD_EXEMPTED_BUNDLE_REQUEST,
    api: `${API.EXEMPTED_BUNDLES.CREATE_COMMON_TASK_FOR_EXEMPTED_BUNDLE}${uuid}`,
    successAction: DOWNLOAD_EXEMPTED_BUNDLE_SUCCESS,
    successCallback,
    failureAction: DOWNLOAD_EXEMPTED_BUNDLE_FAILURE,
    failureCallBack,
    failureMessage: 'Failed to request download',
});

export const fetchExemptedBundlesList = (page, size, searchConstruct, seekParams, seekDirection) => ({
    type: FETCH_EXEMPTED_POLICY_BUNDLES,
    api: API.EXEMPTED_BUNDLES.LIST,
    page,
    size,
    searchConstruct,
    seekParams,
    seekDirection,
});
